export default function Step({ number, title, description }) {
  return (
    <div className="howitworks-card">
      <div className="step-number">
        {number}
      </div>
      <h3>
        {title}
      </h3>
      <p>
        {description}
      </p>
    </div>
  )
}